import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { fetchTrainingSurvey } from "../../../api/SurveyAPI.js";
import SurveyEditor from "../../../components/adhara/admin/survey/SurveyEditor.js";
import SurveyResponses from "../../../components/adhara/admin/survey/SurveyResponses.js";
import APIFetcher from "../../../components/loading/APIFetcher.js";
import AdminTrainingLayout from "../../../layouts/AdminTrainingLayout.js";

const ManageTrainingSurvey = () => {
  const { trainingId } = useParams();

  const [survey, setSurvey] = useState({});

  const fetchItems = () => fetchTrainingSurvey(trainingId).then(setSurvey);

  return (
    <AdminTrainingLayout trainingId={trainingId}>
      <APIFetcher fetchItems={fetchItems}>
        <SurveyResponses survey={survey} />
        <SurveyEditor
          sections={survey.sections}
          surveyId={survey.id}
          onChange={(edit) =>
            setSurvey((prev) => ({ ...prev, sections: edit(prev.sections) }))
          }
        />
      </APIFetcher>
    </AdminTrainingLayout>
  );
};

export default ManageTrainingSurvey;
